import GradientBorderRadius from "@/ui/gradient-border-radius";
import { useLogout } from "@/api/auth";

const LogoutAdmin = () => {
  const handleLogout = useLogout();

  return (
    <GradientBorderRadius radius="bigger" gradient="50" hover="r-100">
      <button
        onClick={handleLogout}
        className="w-[6.3750rem] h-[1.8750rem] rounded-3xl dark:text-white font-semibold text-xs"
      >
        Logout
      </button>
    </GradientBorderRadius>
  );
};

export default LogoutAdmin;
